import { render, staticRenderFns } from "./patent.vue?vue&type=template&id=c9447734&scoped=true&"
import script from "./patent.vue?vue&type=script&lang=js&"
export * from "./patent.vue?vue&type=script&lang=js&"
import style0 from "./patent.vue?vue&type=style&index=0&id=c9447734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9447734",
  null
  
)

export default component.exports